/**
 * 操作车队档案
 */
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Select, Radio } from 'antd';
import { cateAllCompanyRequest } from '@/service/fleetRisk';
import { upsertCompany } from '@/service/safeReport';

/** 大陆手机号（与编辑联系方式同字段校验一致）：1 开头第二位 3-9，共 11 位数字 */
const MOBILE_PHONE_PATTERN = /^1[3-9]\d{9}$/;

/** 输入时剔除文字等非数字字符，仅保留数字 */
const sanitizePhoneInput = (value: string) => (value || '').replace(/\D/g, '').slice(0, 11);

const phoneRules = [
  { required: true, message: '请输入联系方式' },
  {
    validator: (_: any, value?: string) => {
      if (!value) {
        return Promise.resolve();
      }
      if (!MOBILE_PHONE_PATTERN.test(value)) {
        return Promise.reject(new Error('请输入正确的电话号码'));
      }
      return Promise.resolve();
    },
  },
];

interface OperateModalProps {
  closeModal: () => void;
  onOk: () => void;
  data?: any;
}
const OperateTeamModal = (props: OperateModalProps) => {
  const [form] = Form.useForm();
  const { closeModal, data, onOk } = props;
  const [submitNoRepetition, setSubmitNoRepetition] = useState(true); // 不能重复请求

  useEffect(() => {
    carInterviewEdit()
  }, []);



  // 编辑的时候赋值
  const carInterviewEdit = async () => {
    const newData:{[key:string]: any} = {}
		newData.head = data.ooe
		newData.tel = sanitizePhoneInput(data.ooePhone || '')
    form.setFieldsValue(newData)
  }

  //车队评级
  const safeGrade = [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
  ]

  //车队状态
  const safeState = [
    { label: '启用', value: '启用' },
    { label: '停用', value: '停用' },
  ]

  // 提交
  const submit = async (values: any) => {
    if (submitNoRepetition) {
      setSubmitNoRepetition(false)
      const params = { ...values };
      params.id = data.companyId;
      const res = await upsertCompany(params);
      if (res.data?.code === 0) {
        message.success('修改成功');
        closeModal();
        onOk()
      }
    }
  }


  return (
    <Modal
      title={'编辑车队'}
      visible
      onCancel={closeModal}
      onOk={() => form.submit()}
      bodyStyle={{ maxHeight: '70vh', overflow: 'auto' }}
      centered
      maskClosable={false}
    >
      <Form
        form={form}
        autoComplete="off"
        onFinish={submit}
        layout="vertical"
        scrollToFirstError>
        <Form.Item
          name="head"
          label="车队长"
          rules={[{ required: true, message: '请输入车队长' }]}
        >
          <Input placeholder="请输入车队长" />
        </Form.Item>
        <Form.Item
          name="tel"
          label="联系方式"
          getValueFromEvent={(e) => sanitizePhoneInput(e?.target?.value)}
          rules={phoneRules}
          validateTrigger={['onChange', 'onBlur']}
        >
          <Input
            placeholder="请输入联系方式"
            maxLength={11}
            inputMode="numeric"
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default OperateTeamModal;
